<template>
  <div class="content-wrapper">
    <section class="content-header">
      <div class="container-fluid">
        <div class="row mb-2">
          <div class="col-sm-6">
            <h1>Merchant Registration Requests</h1>
          </div>
          <div class="col-sm-6">
            <ol class="breadcrumb float-sm-right">
              <li class="breadcrumb-item">
                <router-link :to="{name: 'Home'}">Home</router-link>
              </li>
              <li class="breadcrumb-item active">Merchant Registration Requests</li>
            </ol>
          </div>
        </div>
      </div>
    </section>

    <section class="content">
      <div class="overlay" v-if="is_loading">
        <i class="fas fa-2x fa-sync-alt fa-spin"></i>
      </div>
      <div class="row">
        <div class="col-12">
          <div class="card">
            <div class="overlay" v-if="is_loading">
              <i class="fas fa-2x fa-sync-alt fa-spin"></i>
            </div>
            <div class="card-header">
              <h3 class="card-title">Detail</h3>
              <div class="card-tools">
                <router-link class="btn btn-info" :to="{name: 'EWMerchantRegistrationRequestList'}">
                  <i class="fas fa-list"></i> List
                </router-link>
              </div>
            </div>
            <div class="card-body">
              <div class="container mt-4">
                <div class="row">
                  <div class="col-md-6">
                    <h6 class="mb-3">Shop Information</h6>
                    <table class="table table-bordered small">
                      <tbody>
                        <tr>
                          <th>Shop Name</th>
                          <td>{{ value.shop_name }}</td>
                        </tr>
                        <tr>
                          <th>Corporate Id</th>
                          <td>{{ value.corporate_id ?? "NULL" }}</td>
                        </tr>
                        <tr>
                          <th>Corporate Name</th>
                          <td>{{ value.corporate_name ?? "NULL" }}</td>
                        </tr>
                        <tr>
                          <th>Country</th>
                          <td>{{ value.country?.name_en }}</td>
                        </tr>
                        <tr>
                          <th>Province</th>
                          <td>{{ value.city?.name_en }}</td>
                        </tr>
                        <tr>
                          <th>Address</th>
                          <td>{{ value.address ?? "NULL" }}</td>
                        </tr>
                        <tr>
                          <th>Contact Number</th>
                          <td>{{ value.contact_number }}</td>
                        </tr>
                        <tr>
                          <th>Shop Image</th>
                          <td>
                            <img
                              v-bind:src="
                                API_ASSET_UPLOAD_URL + value.shop_image
                              "
                              class="img-fluid img-thumbnail rounded"
                              style="width: 120px"
                            />
                          </td>
                        </tr>
                        <tr>
                          <th>Shop Certificate</th>
                          <td>
                            <img
                              v-bind:src="
                                API_ASSET_UPLOAD_URL +
                                value.shop_certificate_image
                              "
                              class="img-fluid img-thumbnail rounded"
                              style="width: 120px"
                            />
                          </td>
                        </tr>
                        <tr>
                          <th>Shop Logo</th>
                          <td>
                            <img
                              v-bind:src="
                                API_ASSET_UPLOAD_URL + value.shop_logo_image
                              "
                              class="img-fluid img-thumbnail rounded"
                              style="width: 120px"
                            />
                          </td>
                        </tr>
                        <tr>
                          <th>Previous Id</th>
                          <td>{{ value.previous_user_id ?? "NULL" }}</td>
                        </tr>
                        <tr>
                          <th>Status</th>
                          <td>{{ value.status }}</td>
                        </tr>
                      </tbody>
                    </table>
                  </div>

                  <!-- Shop Owner Information Second -->
                  <div class="col-md-6">
                    <h6 class="mb-3">Shop Owner Information</h6>
                    <table class="table table-bordered small">
                      <tbody>
                        <tr>
                          <th>ID</th>
                          <td>{{ value.id }}</td>
                        </tr>
                        <tr>
                          <th>First Name</th>
                          <td>{{ value.first_name }}</td>
                        </tr>
                        <tr>
                          <th>Email</th>
                          <td>{{ value.email ?? "NULL" }}</td>
                        </tr>
                        <tr>
                          <th>Gender</th>
                          <td>{{ value.gender }}</td>
                        </tr>
                        <tr>
                          <th>Date of Birth</th>
                          <td>{{ value.date_of_birth }}</td>
                        </tr>
                        <tr>
                          <th>Id Card Number</th>
                          <td>{{ value.id_card_number ?? "NULL" }}</td>
                        </tr>
                        <tr>
                          <th>Id Card Picture</th>
                          <td>
                            <img
                              v-bind:src="
                                API_ASSET_UPLOAD_URL + value.id_card_picture
                              "
                              class="img-fluid img-thumbnail rounded"
                              style="width: 120px"
                            />
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

    </section>
  </div>
</template>

<script>
// import MasterLayout from "@/components/layouts/MasterLayoutComponent.vue";
import {DepartmentsAPI} from '@/services/api'
import axios from 'axios'
import { Notification } from 'element-ui'
const fileDownload = require("js-file-download")


export default {
  name: 'EWMerchantRegistrationRequestShow',
  metaInfo: {
    title: 'EW Merchant Registration Request | Dotlines'
  },
  data: () => ({
    value: {

    },
    pre: {

    },
    is_loading: false
  }),
  mounted: function () {
    this.initialize()
  },
  methods: {

    async initialize () {
      this.is_loading = true
      this.params = this.$route.params

      await this.getDetail(this.params.id).then(response => {
        this.value = response.data
      });

      this.is_loading = false
    },
    downloadFile: function(url) {
      this.is_loading = true
      axios.get(this.API_ASSET_UPLOAD_URL+url, {responseType: "arraybuffer"})
        .then(response => {
          fileDownload(response.data, url.replaceAll("/", "-"))
          Notification.success({ title: 'Download Completed', message: 'Download completed successfully', type: 'success' })
        })
        .catch(error => {
          Notification.error({ title: 'Download Failed', message: 'Failed to download', type: 'error' })
        })
        .finally(() => {
          this.is_loading = false
        });
    },
    getDetail: function (id) {
      return new Promise((resolve, reject) => {
        // eslint-disable-next-line camelcase
        const api_url = '/ew_merchant_registration_requests/' + id;
        axios.get(api_url)
          .then(response => {
            resolve(response)
          })
          .catch((error) => {
            console.log('error ' + error)
            reject(error)
          })
          .finally(() => {
          });
      })
    },
  },
  /* created() {
    this.$emit("update:layout", MasterLayout);
  }, */
}
</script>
